// extracted by mini-css-extract-plugin
module.exports = {"bpm-filter__inputs":"bpm-filter_bpm-filter__inputs__p1IHo","bpm-filter__inputs-divider":"bpm-filter_bpm-filter__inputs-divider__FP2Gk"};